
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"40","height":"40","rx":"20","fill":"#EAEDF2"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M19.262 18.16l1.125-1.708c.459-.709 1.625-.709 2.042 0l3.125 4.791c.25.417.25.875.042 1.292a1.201 1.201 0 01-1.084.667h-8.166c-.459 0-.875-.25-1.084-.667a1.304 1.304 0 01.042-1.292l1.958-3c.459-.666 1.5-.708 2-.083zm-.958.958l-1.875 2.75h7.959l-2.959-4.583-1.583 2.458c-.25.375-.875.375-1.125 0l-.417-.625z","fill":"#586E8C"}}),_c('path',{attrs:{"d":"M17.47 15.202c0 .583-.457 1-1 1-.582 0-1-.417-1-1 0-.542.417-1 1-1 .543 0 1 .458 1 1z","fill":"#586E8C"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M28 26.202a2.659 2.659 0 002.667-2.667V11.979h.666a.685.685 0 00.667-.666c0-.334-.333-.667-.667-.667H8.667a.685.685 0 00-.667.667c0 .375.292.666.667.666h.666v11.556c0 1.5 1.167 2.667 2.667 2.667h7.333v.86L15.5 30.855c-.25.292-.25.709 0 .959s.708.25.958 0L20 28.27l3.5 3.542c.125.125.292.166.5.166a.626.626 0 00.458-.166c.25-.25.25-.667 0-.959l-3.791-3.791v-.861H28zm0-1.334c.708 0 1.333-.583 1.333-1.333V11.979H10.667v11.556c0 .75.583 1.333 1.333 1.333h16z","fill":"#586E8C"}})])
          )
        }
      }
    